import { InjectionToken } from '@angular/core';

export const TOOLTIP_DATA = new InjectionToken<any>('TOOLTIP_DATA');
